var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 4.00016C1.3335 2.5274 2.5274 1.3335 4.00016 1.3335C5.47292 1.3335 6.66683 2.5274 6.66683 4.00016C6.66683 5.24272 5.81698 6.28679 4.66683 6.58282V10.6668C4.66683 11.035 4.96531 11.3335 5.3335 11.3335H9.41751C9.71354 10.1833 10.7576 9.3335 12.0002 9.3335C13.4729 9.3335 14.6668 10.5274 14.6668 12.0002C14.6668 13.4729 13.4729 14.6668 12.0002 14.6668C10.7576 14.6668 9.71354 13.817 9.41751 12.6668H5.3335C4.22893 12.6668 3.3335 11.7714 3.3335 10.6668V6.58282C2.18334 6.28679 1.3335 5.24272 1.3335 4.00016ZM4.00016 2.66683C3.26378 2.66683 2.66683 3.26378 2.66683 4.00016C2.66683 4.73654 3.26378 5.3335 4.00016 5.3335C4.73654 5.3335 5.3335 4.73654 5.3335 4.00016C5.3335 3.26378 4.73654 2.66683 4.00016 2.66683ZM12.0002 10.6668C11.2638 10.6668 10.6668 11.2638 10.6668 12.0002C10.6668 12.7365 11.2638 13.3335 12.0002 13.3335C12.7365 13.3335 13.3335 12.7365 13.3335 12.0002C13.3335 11.2638 12.7365 10.6668 12.0002 10.6668Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtask);
export default __webpack_public_path__ + "static/media/subtask.4325204444ba68a958c9e416731cf370.svg";
export { ForwardRef as ReactComponent };